import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Icon from '@projeccions-pdc/react-icon';
import './Menu.css';

const drawerStyles = theme => ({
    rootList: {
        padding: '7px 18px!important'
    },
    rootListFullWidth: {
        padding: '0px!important',
        textAlign: 'center',
        // height: '54px',
    },
    buttonList: {
        '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.1)'
        }
    },
    button: {
        //margin: theme.spacing.unit,
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1201,
    },
    drawer: {
        position: 'absolute',
        top: '55px',
        left: 0,
        height: 'auto',
        width: '75px',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    // avatarContainer: {
    //     // display: 'inline-block',
    //     position: 'relative',
    //     margin: '15px',
    //     marginTop: '40px',
    //     height: '60px',
    // },
    // avatar: {
    //     width: 60,
    //     height: 60,
    //     // position: 'relative',
    // },
    topNavStyle: {
        textAlign: 'center',
        // width: '200px',
        zIndex: 10,
    },
    // iconContainer: {
    //     position: 'absolute',
    //     bottom: '0px',
    //     right: '0px',
    //     cursor: 'pointer'
    // },
    // nameListItem: {
    //     fontSize: '18px',
    //     color: '#000',
    //     display: 'inline-block',
    //     verticalAlign: 'middle',
    //     // marginLeft: '11px'
    // },
    drawerPaperClose: {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        width: '70px',
    },
});

class CharlyDrawer extends Component {
    state = {
        open: false,
    };

    toggleDrawer = () => {
        this.setState({ open: !this.state.open });
    }

    closeDrawer = () => {
        this.setState({ open: false });
    };

    handleItemClick = (idx) => {
        this.props.handleSetActive(idx);
        setTimeout(() => this.closeDrawer(), 500);
    }

    render() {
        const { classes } = this.props;
        return (
            <div>
                {this.props.children ?
                    <div style={{ display: 'inline-block' }} onClick={this.toggleDrawer}>
                        {this.props.children}
                    </div>
                    :
                    <IconButton className={classes.button} aria-label="Menu" onClick={this.toggleDrawer}>
                        <div><Icon name='md-menu' primaryColor={'#fff'} /></div>
                    </IconButton>
                }
                <Drawer
                    // variant={this.props.drawerModePermanent === true ? 'permanent' : undefined}
                    open={this.state.open}
                    onClose={this.closeDrawer}
                    classes={{
                        paper: classNames(classes.drawer, !this.state.open && classes.drawerPaperClose),
                    }}
                >
                    <div className={classes.topNavStyle}>
                        <List defaultValue={1}>
                            {this.props.navigation.map((element, i) => {
                                return (
                                    <ListItem
                                        key={i}
                                        button
                                        value={i}
                                        className='pdc-menu-item'
                                        onClick={element.reactComponent !== undefined ? () => this.handleItemClick(i) : undefined}
                                        classes={{
                                            root: element.reactComponent !== undefined ? classes.rootList : classes.rootListFullWidth,
                                            button: classes.buttonList
                                        }} >
                                        {element.reactComponent !== undefined ?
                                            <ListItemIcon>
                                                {element.iconElement}
                                            </ListItemIcon>
                                            :
                                            element.iconElement
                                        }
                                    </ListItem>
                                );
                            })}
                        </List>
                    </div>
                </Drawer>
            </div>
        );
    }
}
CharlyDrawer.propTypes = {
    classes: PropTypes.object.isRequired,
    navigation: PropTypes.array.isRequired,
    handleSetActive: PropTypes.func.isRequired,
    drawerModePermanent: PropTypes.bool.isRequired,
};

export default withStyles(drawerStyles)(CharlyDrawer);